import Vue from 'vue';
import VueRouter, { Route } from 'vue-router';
import BuddyResponse from '@/views/BuddyResponse.vue';
import NotFoundComponent from '../views/404.vue';
import ForbiddenComponent from '../views/403.vue';
import ErrorNotifier from '../views/ErrorNotifier.vue';
import authRoutes from './auth';
import forumRoutes from './forum';
import ForumComingSoon from '@/views/ForumComingSoon.vue';
import PrivacyStatment from '@/views/PrivacyStatement.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    redirect: { name: 'AppLogin' },
  },
  {
    path: '/buddy-reply',
    props: (route: Route) => ({ buddyCode: route.query.buddyCode, buddyStatus: route.query.buddyStatus }),
    component: BuddyResponse
  },
  {
    path: '/coming-soon',
    name: 'ComingSoon',
    component: ForumComingSoon
  },
  {
    path: '/privacy_statement',
    name: 'PrivacyStatement',
    component: PrivacyStatment
  },
  {
    path: '/403',
    name: '403',
    component: ForbiddenComponent
  },
  {
    path: '/404',
    name: '404',
    component: NotFoundComponent
  },
  {
    path: '/500',
    name: '500',
    component: ErrorNotifier
  },
  {
    path: '*',
    redirect: { name: '404' }
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [...routes, ...authRoutes, ...forumRoutes] as any,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

export default router;
